module.exports = __webpack_public_path__ + "img/phone.a916bdc5.png";